import "moment/locale/th";

import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  Row,
  Table,
} from "reactstrap";
import {
  GET_METER,
  GET_RP_ACTIVITY_ENTRY,
  GET_RP_ACTIVITY_EXIT,
  GET_RP_SUPPLY_DEMAND,
  GET_RP_SUPPLY_DEMAND_ENTRY,
  GET_RP_SUPPLY_DEMAND_EXIT,
  GET_ZONE,
  SAVE_RP_SUPPLY_DEMAND_ENTRY,
  SAVE_RP_SUPPLY_DEMAND_EXIT
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { groups } from "../../../../common/data/chat";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SupplyDemandPlan(props) {
  // console.log(props);
  const dispatch = useDispatch();
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined,{
      minimumFractionDigits:digit,
    });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const ToNumberFormat = (cell, row, rowIndex) => numberFormat(cell, 2);
  const [columnsSummary, setColumnsSummary] = useState([
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Location",
      headerAlign: "center",
      align: "center",

      headerStyle: {
        backgroundColor: "rgb(100, 120, 215)",
        color: "#46FCFF",
      },
      // sort: true,
    },
    {
      dataField: "ACTIVITY_PLAN_ENTRY",
      text: "Entry(Weekly Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        // console.log(row)
        let className = "";
        if (row.ENTRY_groups != null)
          className = `ENTRY_WEEKLY_PLAN ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "rgb(85, 110, 230)",
        color: "#46FCFF",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
    {
      dataField: "ACTIVITY_ACTUAL_ENTRY",
      text: "Entry(Daily Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `ENTRY_DAILY_PLAN ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "rgb(85, 110, 230)",
        color: "#46FCFF",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },

    {
      dataField: "ACTIVITY_PLAN_EXIT",
      text: "Exit(Weekly Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `EXIT_WEEKLY_PLAN ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#5868b785",
        color: "#46FCFF",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
    {
      dataField: "ACTIVITY_ACTUAL_EXIT",
      text: "Exit(Daily Plan)",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `EXIT_DAILY_PLAN ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#5868b785",
        color: "#46FCFF",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },

  ]);
  // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
  //     "YYYY-MM-DD"));
  //   const searchDate = { SELECT_DATE: props.date };

  const columnColor = [
    "rgb(126 142 218)",
    "rgb(100 120 215)",
    "rgb(85 110 230)",
    "rgb(67 98 248)",
  ];



  const [modelDeviceList, setModelDeviceList] = useState([]);


  const [dataListMerge, setDataListMerge] = useState({ entryDataList: [], exitDataList: [], dtEntry: [], dtExit: [] })





  const rowStyleSummary = (row, rowIndex) => {
    const style = {};
    if (rowIndex == modelDeviceList.length - 1) {
      style.backgroundColor = "#556ee64a";
      style.color = "#FFFFFF";
    } else {
      style.color = "#FFFFFF";
    }
    style.verticalAlign='middle'
    return style;
  };

  //headerColumn
  useEffect(() => {
    let classMerged = [];
    function mergeCell(index) {
      if (classMerged.indexOf($(this).attr("class")) == -1) {
        let [field, group, rowspan] = $(this).attr("class")?.split(/\s+/);
        $(this).attr("rowspan", rowspan.replaceAll("rowspan", ""));
        $(`.${field}.${group}.${rowspan}`).not(":first").hide();
      }
      classMerged.push($(this).attr("class"));
    }
    $(".ENTRY_WEEKLY_PLAN").each(mergeCell);
    $(".ENTRY_DAILY_PLAN").each(mergeCell);
    $(".EXIT_WEEKLY_PLAN").each(mergeCell);
    $(".EXIT_DAILY_PLAN").each(mergeCell);

  }, [modelDeviceList]);





  const addHeaderTable = () => {
    let prevHeader1 = document.getElementById("supply-demand-plan-header1");
    prevHeader1 && prevHeader1.remove();
    let prevHeader2 = document.getElementById("supply-demand-plan-header2");
    prevHeader2 && prevHeader2.remove();
    let prevFooter = document.getElementById("supply-demand-plan-footer");
    prevFooter && prevFooter.remove();
    let thead = document
      .getElementById("supply-demand-plan-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="supply-demand-plan-header1" colspan="' +
      3 +
      '" style="text-align:center;background-color:#556ee678;color:#46FCFF">Today Supply & Demand Plan</th><th id="supply-demand-plan-header2" colspan="' +
      2 +
      '" style="text-align:center;background-color:#5868b785;color:#46FCFF;text-align:right">Unit: MMscfd</th>';
    thead.prepend(tr);

    let table = document
      .getElementById("supply-demand-plan-table")

    // let tfooter = document.createElement("tfooter");
    // tfooter.innerHTML =
    //     '<tfooter id="supply-demand-plan-footer"><tr><td colspan="3" style="text-align:center;background-color:#556ee678;color:#46FCFF">Khanom ( Of ปริมาณรวมอยู่ในตะวันออก )</td><td style="text-align:center;background-color:#556ee678;color:#7AE3F7">0</td><td style="text-align:center;background-color:#556ee678;color:#7AE3F7">0</td></tr></tfooter>';
    //     table.appendChild(tfooter);
  };
  const getColumnEntry = () => post(GET_RP_SUPPLY_DEMAND_ENTRY, {});
  const getColumnExit = () => post(GET_RP_SUPPLY_DEMAND_EXIT, {});




  const generateRow = () => {
 
    let entryList = [
      ...dataListMerge.entryDataList.filter(row => row.SUPPLYDEMAND_SHOW == true),
    ];
    let exitList = [
      ...dataListMerge.exitDataList.filter(row => row.SUPPLYDEMAND_SHOW == true),
    ];
    let rowData = [];

    entryList.map(row => {
    
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`ENTRY_${key}`] = value;
      }

      let prevData = rowData.find(prev => prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME)
      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj }
          }
          return prev
        })
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME
        rowData.push(obj);
      }
    });
    exitList.map(row => {

      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`EXIT_${key}`] = value;
      }

      let prevData = rowData.find(prev => prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME)

      if (prevData) {

        rowData = rowData.map(prev => {
          
          if (prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME) {
         
            return { ...prev, ...obj }
          }
          return prev
        })
       
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME
        rowData.push(obj);
      }

    });
    rowData = rowData.map((row, index) => ({ ...row, row: index }))
    let tempRowData = addFieldToModelDeviceList(rowData);
    // console.log(tempRowData)
    if (tempRowData) setModelDeviceList([...tempRowData]);
  };



  const fetchData = async () => {
    function compare(a, b) {
      if (a.SUPPLYDEMAND_ORDER < b.SUPPLYDEMAND_ORDER) {
        return -1;
      }
      if (a.SUPPLYDEMAND_ORDER > b.SUPPLYDEMAND_ORDER) {
        return 1;
      }
      return 0;
    }

    dispatch(loadingAction.showLoading());
    try {
      let [entry, exit, dtEntry, dtExit] = await Promise.all([
        getColumnEntry(),
        getColumnExit(),
        post(GET_RP_ACTIVITY_ENTRY, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
        post(GET_RP_ACTIVITY_EXIT, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
      ]);
      // console.log(entry,exit,dtEntry,dtExit)
      setDataListMerge({
        entryDataList: entry.data.rpSupplyDemandEntryList.sort(compare).filter(obj => obj.SUPPLYDEMAND_SHOW == true).map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        })), exitDataList: exit.data.rpSupplyDemandExitList.sort(compare).filter(obj => obj.SUPPLYDEMAND_SHOW == true).map((obj, index) => ({
          ...obj,
          ROW: index + 1,

        })), dtEntry: dtEntry.data.rpActivityEntryList,
        dtExit: dtExit.data.rpActivityExitList,
      })

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  



  useEffect(() => {
    addHeaderTable()
  }, []);

  useEffect(() => {
    // console.log(props.summaryReportPid)
    fetchData();
  }, [props.summaryReportPid]);
  useEffect(() => {
    if (dataListMerge.entryDataList.length > 0 || dataListMerge.exitDataList.length > 0) {
      // console.log(3)
      generateRow();
    }
  }, [dataListMerge]);

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      SUPPLYDEMAND_PID: "",
      SUPPLYDEMAND_ORDER: 0,
      SUPPLYDEMAND_NAME: "",
      ACTIVITY_PLAN_ENTRY: "",
      ACTIVITY_ACTUAL_ENTRY: "",
      SUPPLY_DIFF_ENTRY: "",
      ACTIVITY_PLAN_EXIT: "",
      ACTIVITY_ACTUAL_EXIT: "",
      DEMAND_DIFF_EXIT: "",
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let mergeEntryCell = [];
      let mergeExitCell = [];
      let notInList = [];
      dataListMerge.entryDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.entryDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {

            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_SET == e.SUPPLYDEMAND_SET &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE
            ) {
              let preventData = mergeEntryCell.find(obj => obj.ENTRY_group == index);
              notInList.push(e.PID);
              if (preventData) {
                mergeEntryCell = [
                  ...mergeEntryCell.map(prev => {
                    if (prev.ENTRY_group == index) {
                      prev.ENTRY_subPid = [...prev.ENTRY_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeEntryCell.push({
                  ENTRY_group: index,
                  ENTRY_mainPid: row.PID,
                  ENTRY_subPid: [e.PID],

                });
              }
            }
          });
      });

      dataListMerge.exitDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.exitDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {

            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE &&
              row.SUPPLYDEMAND_SET1 == e.SUPPLYDEMAND_SET1 &&
              row.SUPPLYDEMAND_OVERHEAD1 == e.SUPPLYDEMAND_OVERHEAD1 &&
              row.SUPPLYDEMAND_DIVISOR1 == e.SUPPLYDEMAND_DIVISOR1 &&
              row.SUPPLYDEMAND_SET2 == e.SUPPLYDEMAND_SET2 &&
              row.SUPPLYDEMAND_OVERHEAD2 == e.SUPPLYDEMAND_OVERHEAD2 &&
              row.SUPPLYDEMAND_DIVISOR2 == e.SUPPLYDEMAND_DIVISOR2

            ) {
              // console.log(2)
              let preventData = mergeExitCell.find(obj => obj.EXIT_group == index);
              notInList.push(e.PID);
              if (preventData) {
                mergeExitCell = [
                  ...mergeExitCell.map(prev => {
                    if (prev.EXIT_group == index) {
                      prev.EXIT_subPid = [...prev.EXIT_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeExitCell.push({
                  EXIT_group: index,
                  EXIT_mainPid: row.PID,
                  EXIT_subPid: [e.PID],

                });
              }
            }
          });
      });
      // console.log(mergeExitCell);
      let modelList = [];
      rowList.map(objRow => {
        // console.log(objRow,dataListMerge.dtEntry)
        let dataEntry = dataListMerge.dtEntry.find(
          row => row.SUPPLYENTRY_PID == objRow.ENTRY_PID
        );
        let dataExit = dataListMerge.dtExit.find(
          row => row.DEMANDEXIT_PID == objRow.EXIT_PID
        );
        // console.log(dataEntry)
        let mergeEntry = mergeEntryCell.find(
          row =>
            objRow.ENTRY_PID == row.ENTRY_mainPid ||
            row.ENTRY_subPid.indexOf(objRow.ENTRY_PID) >= 0
        );
        let mergeExit = mergeExitCell.find(
          row =>
            objRow.EXIT_PID == row.EXIT_mainPid ||
            row.EXIT_subPid.indexOf(objRow.EXIT_PID) >= 0
        );
        // console.log(mergeExit);
        modelList.push({
          ...dataModel,
          ...objRow,
          ...dataEntry,
          ...dataExit,
          ENTRY_groups: mergeEntry ? mergeEntry.ENTRY_group : null,
          ENTRY_rowspan: mergeEntry ? mergeEntry.ENTRY_subPid.length + 1 : null,
          EXIT_groups: mergeExit ? mergeExit.EXIT_group : null,
          EXIT_rowspan: mergeExit ? mergeExit.EXIT_subPid.length + 1 : null,
        });
      });
      // console.log(modelList);
      rowList.map(objRow => ({ ...dataModel, ...objRow }));
      let totalRow = modelList.reduce(function (accumulator, item) {
        accumulator["ACTIVITY_PLAN_ENTRY"] =
          (accumulator["ACTIVITY_PLAN_ENTRY"] || 0) + item["ACTIVITY_PLAN_ENTRY"];
        accumulator["ACTIVITY_ACTUAL_ENTRY"] =
          (accumulator["ACTIVITY_ACTUAL_ENTRY"] || 0) +
          item["ACTIVITY_ACTUAL_ENTRY"];
        accumulator["ACTIVITY_PLAN_EXIT"] =
          (accumulator["ACTIVITY_PLAN_EXIT"] || 0) + item["ACTIVITY_PLAN_EXIT"];
        accumulator["ACTIVITY_ACTUAL_EXIT"] =
          (accumulator["ACTIVITY_ACTUAL_EXIT"] || 0) + item["ACTIVITY_ACTUAL_EXIT"];
        return { ...dataModel, ...accumulator, SUPPLYDEMAND_NAME: "Total" };
      }, {});
      let entryReduce = mergeEntryCell.reduce((total, item) => {
        let temp = dataListMerge.dtEntry.find(
          row => item.ENTRY_subPid.indexOf(row.SUPPLYENTRY_PID) >= 0
        );
        if (temp) {
          total.ACTIVITY_PLAN_ENTRY = total.ACTIVITY_PLAN_ENTRY + temp.ACTIVITY_PLAN_ENTRY;
          total.ACTIVITY_ACTUAL_ENTRY = total.ACTIVITY_ACTUAL_ENTRY + temp.ACTIVITY_ACTUAL_ENTRY;
        }
        return { ...total };
      }, { ACTIVITY_PLAN_ENTRY: 0, ACTIVITY_ACTUAL_ENTRY: 0 });
      let exitReduce = mergeExitCell.reduce((total, item) => {
        let temp = dataListMerge.dtExit.find(
          row => item.EXIT_subPid.indexOf(row.DEMANDEXIT_PID) >= 0
        );
        if (temp) {
          total.ACTIVITY_PLAN_EXIT = total.ACTIVITY_PLAN_EXIT + temp.ACTIVITY_PLAN_EXIT;
          total.ACTIVITY_ACTUAL_EXIT = total.ACTIVITY_ACTUAL_EXIT + temp.ACTIVITY_ACTUAL_EXIT;
        }
        return { ...total };
      }, { ACTIVITY_PLAN_EXIT: 0, ACTIVITY_ACTUAL_EXIT: 0 });
      totalRow.ACTIVITY_PLAN_ENTRY =
        totalRow.ACTIVITY_PLAN_ENTRY - entryReduce.ACTIVITY_PLAN_ENTRY;

      totalRow.ACTIVITY_ACTUAL_ENTRY =
        totalRow.ACTIVITY_ACTUAL_ENTRY - entryReduce.ACTIVITY_ACTUAL_ENTRY;

      totalRow.ACTIVITY_PLAN_EXIT =
        totalRow.ACTIVITY_PLAN_EXIT - exitReduce.ACTIVITY_PLAN_EXIT;

      totalRow.ACTIVITY_ACTUAL_EXIT =
        totalRow.ACTIVITY_ACTUAL_EXIT - exitReduce.ACTIVITY_ACTUAL_EXIT;
      // console.log(totalRow)
      // console.log(totalRow.SUPPLY_PLAN_ENTR,)

      return [...modelList, totalRow];
    }
  };

  return (
    <div>

      <Row className="mt-0">
        <Col lg="12">
          <div>
            {/* <BootstrapTable
              keyField="PID"
              data={modelDeviceListSummary}
              columns={columnsSummary}
              headerClasses="header-style"
              rowStyle={rowStyleSummary}
              // defaultSorted={defaultSorted}
              // pagination={paginationFactory(options)}
              // hover
            /> */}
            <BootstrapTable
              id="supply-demand-plan-table"
              wrapperClasses="table-on-scroll"
              keyField="SUPPLYDEMAND_NAME"
              data={modelDeviceList}
              columns={columnsSummary}
              rowStyle={rowStyleSummary}
              // rowClasses={rowClass}
              headerClasses="header-style"
            />
          </div>

        </Col>

      </Row>



    </div>
  );
}

SupplyDemandPlan.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any
};

export default SupplyDemandPlan;
